/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
import { BffFacility, ContentTile as TContentTile } from '@/types/generated';
import { dataLayerConfig } from '@/utils';

export function useAnalyticsTracking() {
	const handleScheduleClick = (scheduleUrl: string, linkText: string) => {
		dataLayerConfig({
			event: 'click_to_scheduler',
			click_name: 'Schedule',
			click_position: 'header',
			link_click_location: 'header',
			page_url: globalThis?.location?.pathname || '/',
			page_name: globalThis?.document?.title || '',
			brand: 'aspendental',
			link_text: linkText,
			link_url: scheduleUrl,
			page_destination_url: scheduleUrl,
			page_origin_name: globalThis?.document?.title || '',
		});
	};

	const handleNavigationClick = (destinationUrl: string, linkText: string) => {
		dataLayerConfig({
			event: 'navigation_click_event',
			brand: 'Aspen Dental',
			page_destination_url: destinationUrl,
			link_click_location: 'header',
			link_text: linkText,
			page_origin_name: globalThis?.document?.title || '',
			page_origin_url: globalThis?.location?.href || '',
		});
	};

	const handleTileClick = (tile: TContentTile, href: string) => {
		dataLayerConfig({
			event: 'navigation_click_event',
			brand: 'Aspen Dental',
			page_destination_url: href,
			link_click_location: 'header',
			link_text: tile.title || '',
			page_origin_name: globalThis?.document?.title || '',
			page_origin_url: globalThis?.location?.href || '',
		});
	};

	const trackFacilitySet = (facility: BffFacility) => {
		if (facility?.code && facility?.name) {
			dataLayerConfig({
				event: 'facility_set',
				brand: 'Aspen Dental',
				website_selected_facility_id: facility.code,
				website_selected_facility_name: facility.name,
				page_origin_name: globalThis?.document?.title,
			});
		}
	};

	const trackPhoneNumber = (phoneNumber: string) => {
		if (phoneNumber) {
			const isTelLink = phoneNumber.startsWith('tel');
			if (isTelLink) {
				// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call

				const formattedPhone: string = phoneNumber
					// @ts-ignore
					.replaceAll(/\D/g, '')
					.replaceAll(/^1/g, '')
					.replaceAll(/(\d{3})(\d{3})(\d{4})/g, '$1-$2-$3');
				dataLayerConfig({
					event: 'invoca_page_load',
					brand: 'Aspen Dental',
					invoca_phone_number: formattedPhone,
					page_origin_name: globalThis?.document?.title || '',
				});
			}
		}
	};

	return {
		handleScheduleClick,
		handleNavigationClick,
		handleTileClick,
		trackFacilitySet,
		trackPhoneNumber,
	};
}
